import { axiosInstance } from "./axios";
import { IMobywatelQRCodeResponse } from "dto/Activation/IMobywatelQRCodeResponse";
import useCustomMutation from "hooks/useCustomMutation";

const getMObywatelQRcode = (): Promise<{
  data: IMobywatelQRCodeResponse;
}> => {
  return axiosInstance.get(`/mobywatel/qrcode`);
};

const useGetMObywatelQRcode = () => {
  return useCustomMutation(getMObywatelQRcode);
};

export default {
  useGetMObywatelQRcode,
};
